import React, { useEffect, useRef, useState } from "react";
import dropdown from "../../../../assets/img/faq-dropdown.svg";
import { FAQS_DATA } from "./faqsData";

function FAQ() {
  const selectedLanguage = localStorage.getItem("language");

  const [faqs, setFaqs] = useState(FAQS_DATA());

  const faqRef = useRef();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (faqRef.current && !faqRef.current.contains(event.target)) {
        // Clicked outside — close all
        setFaqs((prevFaqs) => prevFaqs.map((item) => ({ ...item, isActive: false })));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleShowAnswer = (id) => {
    const updatedFaqs = faqs.map((item) => {
      if (item.id === id) {
        return { ...item, isActive: !item.isActive };
      } else {
        return { ...item, isActive: false };
      }
    });

    setFaqs(updatedFaqs);
  };

  return (
    <div>
      <div className=" w-100 pt-5" style={{ paddingBottom: "3rem" }}>
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 18px",
            direction: selectedLanguage === "ARABIC" ? "rtl" : "ltr",
          }}
        >
          <p className={`faq-text py-4 ${selectedLanguage === "arabic" ? "rtl text-right" : "ltr text-left"}`}>{`${
            selectedLanguage === "arabic" ? "الأسئلة الشائعة" : "FREQUENTLY ASKED QUESTIONS"
          } `}</p>
          <div ref={faqRef}>
            {faqs?.map((item, index) => {
              return (
                <div key={index} className={`${item?.isActive ? "faq-active-wrapper" : "bg-transparent"} p-5`}>
                  <div
                    className={`w-100 d-flex justify-content-between align-items-baseline cursor-pointer ${
                      selectedLanguage === "arabic" ? "flex-row-reverse" : "flex-row"
                    }`}
                    onClick={() => handleShowAnswer(item?.id)}
                  >
                    <p
                      className={`${item?.isActive ? "question-text-active" : "question-text"} ${
                        selectedLanguage === "arabic" ? "pl-3 text-right" : "pr-3 text-left"
                      }`}
                    >
                      {item?.question}
                    </p>

                    <img className={`${item?.isActive ? "rotate-360" : "rotate-180"} dropdown-faq-img`} src={dropdown} alt="dropdown" />
                  </div>
                  {item?.isActive ? (
                    <div className="">
                      {item?.answer?.title ? (
                        <div className={`pt-4 answer-text ${selectedLanguage === "arabic" ? "rtl text-right" : "ltr text-left"}`}>
                          {item?.answer?.title}
                        </div>
                      ) : null}
                      {item?.answer?.points?.length > 0 ? (
                        <div className={`${item?.id === "7" && "pt-4"} `}>
                          <ul className="list-disc px-4 answer-text">
                            {item?.answer?.points?.map((point) => {
                              return (
                                <>
                                  <li className={`py-1 ${selectedLanguage === "arabic" ? "rtl text-right" : "ltr text-left"} `}>{point?.text}</li>
                                </>
                              );
                            })}
                          </ul>
                        </div>
                      ) : null}
                      {item?.answer?.description ? (
                        <div className={`pt-4 answer-text ${selectedLanguage === "arabic" ? "rtl text-right" : "ltr text-left"}`}>
                          {item?.answer?.description}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQ;
